import { Component,OnInit, ViewChild, ElementRef } from '@angular/core';
import { ChartType, ChartOptions,ChartDataSets, RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {ReportserviceService}  from '../../reportservice.service';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';
import {OptListByDate,OptListByMonth,OptListByDoctor} from '../opd-date-wise-report/optdata'
import { AuthService } from 'app/auth/auth.service';


@Component({
  selector: 'app-opdreports',
  templateUrl: './opdreports.component.html',
  styleUrls: ['./opdreports.component.scss']
})
export class OpdreportsComponent implements OnInit {

  patientcount;
  dataSource = new MatTableDataSource<PatientDetailModel>();
  startdate;
  enddate;
  pname = "";
  pageHeading:any;
  public toDaysDate:any;
   
  public OpdDoctorArray:any =[];
  isShowDivIf = false;
  isGraph = false;
  ismonthly = false;
  isgrapandData = false;
  isdatewise = false;
  isnewcolor =false;
  isBarChart=false;

  grandTotal:any;
  freshTotal:any;
  reviewTotal:any;
  maleTotal:any;
  femaleTotal:any;
  crossReffTotal:any;
  dialtedTotal:any;
  walkingTotal:any;
  appointmentTotal:any;
  TatTotal:any;
  ReportType:any;


  public commonParamete:any;
  public checkReportType:number;
  public setcharttype;
  public senddataArray:any = [];
  public serchdata:any =[];
  public Labels =['Total','Fresh','Review','Male','Female','Cross Reff',
  'Dilated','Walk In','With Appt','TAT'];
  public GraphLabels:any =[]
  public NewLabelData:any=[];
  
  public pieChartOptions: ChartOptions = {
    responsive: true,
    tooltips: {enabled: false},
    hover: {mode: null},
    events: []
  };
  public pieChartData: ChartDataSets[] = [
    { data: [ ], label: ' ' }
  ];
  public pieChartLabels: Label[] = this.Labels;
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public pieChartDataArray:any =[];
  lineChartLegend = true;
   barChartLegend = true;

  // Define type of chart
  lineChartType = 'line';

  lineChartPlugins = [];
  
  
  constructor(public reportservice:ReportserviceService,public dbservice:DashboardService, 
    public opdvisitService: OpdVisitService, public authService :AuthService,
    private datePipe: DatePipe,private exportdata:ExportService) {
        monkeyPatchChartJsTooltip();
        monkeyPatchChartJsLegend();
     
        }
  
    ngOnInit(): void {
      this.startdate = this.authService.getServerDate;
      this.enddate = this.authService.getServerDate;
      this.toDaysDate = this.authService.getServerDate;
      this.toDaysDate = this.datePipe.transform(this.toDaysDate, "yyyy-MM-dd");
      console.log(this.toDaysDate);
      this.commonParamete =this.toDaysDate;
      // this.reportservice.getOpdCommonReport(this.toDaysDate,this.toDaysDate,this.commonParamete).
      // subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
     
      this.checkReportType = 1;
      this.ReportType='Date';
      this.setPageHeading();
      this.opdReortType();
      }

  opdReortType() {
    switch (this.dbservice.reportTitle) {
      case 'Doctor_Wise_Advice_Investigation':
        {
          this.commonParamete = 'DOCTOR';
          this.ReportType = 'Doctor';
          this.checkReportType = 3;
          this.get_records_between_two_dates();
          break;
        }
      case 'OPD_Patient_Register_DateWise':
        {
          this.commonParamete = this.toDaysDate;
          this.ReportType = 'Date';
          this.get_records_between_two_dates();
          break;
        }
      case 'OPD Register Date Wise':
        {
          this.commonParamete = this.toDaysDate;
          this.ReportType = 'Date';
          this.get_records_between_two_dates();
          break;
        }
      case 'OPD Summary Daily':
        {
          this.commonParamete = this.toDaysDate;
          this.ReportType = 'Date';
          this.get_records_between_two_dates();
          break;
        }
      case 'OPD Summary Doctor Daily':
        {
          this.commonParamete = this.toDaysDate;
          this.ReportType = 'Daily';
          this.setDailyBargraphData();
          break;
        }
      case 'OPD Summary Doctor Monthly':
        {
          this.commonParamete = 'monthly';
          this.ReportType = 'Monthly';
          this.setMonthelyBargraphData();
          break;
        }
      case 'OPD Summary Doctor Quarterly':
        {
          this.commonParamete = 'quarterly';
          this.ReportType = 'Quarterly';
          this.setQuaterlyBargraphData();
          break;
        }
      case 'OPD Summary Doctor Yearly':
        {
          this.commonParamete = 'yearly';
          this.ReportType = 'Yearly';
          this.setYearlyBargraphData();
          break;
        }
        default: { 
          this.get_records_between_two_dates();
          break; 
       } 
    }

  }

  setPageHeading() {
    let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
    this.pageHeading = `OPD ${this.ReportType} Wise  Reports From ${sdate} To ${edate}`;
  }
  
 
  
  toggleDisplayDivIf() {
    this.isShowDivIf = !this.isShowDivIf;
  }
  
  togglegraphIf() {
    this.isGraph = !this.isGraph;
  }
  
  togglegraphDataIf() {
    this.isgrapandData = !this.isgrapandData;
  }
  

  GetTotal(data:any){
    this.grandTotal = 0;
    this.freshTotal = 0;
    this.reviewTotal = 0;
    this.maleTotal = 0;
    this.femaleTotal = 0;
    this.crossReffTotal = 0;
    this.dialtedTotal = 0;
    this.walkingTotal = 0;
    this.appointmentTotal = 0;
    this.TatTotal = 0;
    
    data.forEach((element:any) => {
     this.grandTotal = this.grandTotal+element.total;
     this.freshTotal = this.freshTotal+element.fresh;
     this.reviewTotal = this.reviewTotal+element.review;
     this.maleTotal = this.maleTotal+element.male;
     this.femaleTotal = this.femaleTotal+element.female;
     this.crossReffTotal = this.crossReffTotal+element.crossReff;
     this.dialtedTotal = this.dialtedTotal+element.dilated;
     this.walkingTotal = this.walkingTotal+element.walkIn;
     this.appointmentTotal = this.appointmentTotal+element.withAppt;
     this.TatTotal = this.TatTotal+element.tat;
   }) ;
  
 }


    getReportsType(name:any){
      console.log( this.checkReportType)
      var val =name.value;
      if(val==1){
        this.commonParamete =this.toDaysDate;
        this.ReportType='Date';
      }
      else if(val==2){
        this.commonParamete ='MONTH';
        this.ReportType='Month';
      }
     else if(val==3){
        this.commonParamete ='DOCTOR';
        this.ReportType='Doctor';
      }
      this.get_records_between_two_dates();
        this.setPageHeading()
        
    }
  
  
  
  get_records_between_two_dates(){
    let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
    this.reportservice.getOpdCommonReport(sdate,edate, this.commonParamete).
    subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
  }
  
  success_pat_sdate_edate(data){
    if(data.length > 0){
     this.OpdDoctorArray =data;
   
    console.log('common data',data);
    this.setBargraphData();
    this.setPageHeading();

    this.GetTotal(this.OpdDoctorArray)
    }
    else{
      this.OpdDoctorArray =[];
    }
   }
  failed_pat_sdate_edate(err){
  // this.showspinner = false;
  }

  // setgraptype(type){
  //   this.pieChartType =type;
  //    this.setgraphData(type);
  //  }

  setPiegraphData(){
    // var Dataarray=[];
    this.pieChartDataArray=[];
    this.NewLabelData=[];
    if(this.OpdDoctorArray.length >0){
      this.OpdDoctorArray.forEach(element => {
        this.pieChartDataArray.push(element.total);
        this.pieChartDataArray.push(element.fresh);
        this.pieChartDataArray.push(element.review);
        this.pieChartDataArray.push(element.male);
        this.pieChartDataArray.push(element.female);
        this.pieChartDataArray.push(element.crossReff);
        this.pieChartDataArray.push(element.dilated);
        this.pieChartDataArray.push(element.walkIn);
        this.pieChartDataArray.push(element.withAppt);
        this.pieChartDataArray.push(element.tat);
      if(element.opdDate !== null){
          this.NewLabelData.push(this.datePipe.transform(element.opdDate, "yyyy-MM-dd") )
        }
        if(element.monthYear !== null){
          this.NewLabelData.push(element.monthYear)
        }
        if(element.doctorName !== null){
          this.NewLabelData.push(element.doctorName)
        }
       });
      }
      this.GraphLabels =['Total','Fresh','Review','Male','Female','Cross Reff',
     'Dilated','Walk In','With Appt','TAT'];
     
      this.pieChartOptions = {
       responsive: true,
        };

      this.pieChartData = [
        { data:this.pieChartDataArray, label: 'OPD Doctor Analysis' }
      ];
      this.pieChartLabels = this.Labels;
      this.pieChartType = 'pie';
      this.pieChartLegend = true;

      this.isBarChart =false;
  
  }


  setLinegraphData(){
    this.isBarChart =true;
    let FreshArray=[];
    let ReviewArray=[];
    this.pieChartDataArray=[];
    this.NewLabelData=[];
    if(this.OpdDoctorArray.length >0){
      this.OpdDoctorArray.forEach(element => {
        // this.pieChartDataArray.push(element.total);
        // this.pieChartDataArray.push(element.fresh);
        // this.pieChartDataArray.push(element.review);

        FreshArray.push(element.fresh);
        ReviewArray.push(element.review);
        
        // this.pieChartDataArray.push(element.male);
        // this.pieChartDataArray.push(element.female);
        // this.pieChartDataArray.push(element.crossReff);
        // this.pieChartDataArray.push(element.dilated);
        // this.pieChartDataArray.push(element.walkIn);
        // this.pieChartDataArray.push(element.withAppt);
        // this.pieChartDataArray.push(element.tat);
        if(element.opdDate !== null){
          this.NewLabelData.push(this.datePipe.transform(element.opdDate, "yyyy-MM-dd") )
        }
        if(element.monthYear !== null){
          this.NewLabelData.push(element.monthYear)
        }
        if(element.doctorName !== null){
          this.NewLabelData.push(element.doctorName)
        }
       });
      }
      console.log( FreshArray, ReviewArray)
      this.GraphLabels = this.NewLabelData;
     
      this.pieChartOptions = {
       responsive: true,
       scales: { xAxes: [{}], yAxes: [{}] },
     };
      this.pieChartData = [
        { data:FreshArray, label: 'OPD Fresh Analysis' },
        { data:ReviewArray, label: 'OPD Review Analysis' }
     ];

     this.lineChartLegend = true;

     // Define type of chart
    //  this.lineChartType = 'line';
   
     this.lineChartPlugins = [];
     this.pieChartLabels =this.Labels;
      this.pieChartType = 'line';
    this.pieChartLegend = true;
    this.isBarChart =false;
   

  }
  setBargraphData(){
    this.isBarChart =true;
    let FreshArray=[];
    let ReviewArray=[];
    this.pieChartDataArray=[];
    this.NewLabelData=[];
    if(this.OpdDoctorArray.length >0){
      this.OpdDoctorArray.forEach(element => {
        // this.pieChartDataArray.push(element.total);
        // this.pieChartDataArray.push(element.fresh);
        // this.pieChartDataArray.push(element.review);

        FreshArray.push(element.fresh);
        ReviewArray.push(element.review);
        
        // this.pieChartDataArray.push(element.male);
        // this.pieChartDataArray.push(element.female);
        // this.pieChartDataArray.push(element.crossReff);
        // this.pieChartDataArray.push(element.dilated);
        // this.pieChartDataArray.push(element.walkIn);
        // this.pieChartDataArray.push(element.withAppt);
        // this.pieChartDataArray.push(element.tat);
        if(element.opdDate !== null){
          this.NewLabelData.push(this.datePipe.transform(element.opdDate, "yyyy-MM-dd") )
        }
        if(element.monthYear !== null){
          this.NewLabelData.push(element.monthYear)
        }
        if(element.doctorName !== null){
          this.NewLabelData.push(element.doctorName)
        }
       });
      }
      console.log( FreshArray, ReviewArray)
      this.GraphLabels = this.NewLabelData;
     
      this.pieChartOptions = {
       responsive: true,
       scales: { xAxes: [{}], yAxes: [{}] },
     };
      this.pieChartData = [
        { data:FreshArray, label: 'OPD Fresh Analysis' },
        { data:ReviewArray, label: 'OPD Review Analysis' }
     ];
     this.barChartLegend = true;
     this.pieChartLabels = this.Labels;
      this.pieChartType = 'bar'
     this.pieChartLegend = true;
  
   

  }

  setDailyBargraphData(){
    this.isBarChart =true;
    // this.isGraph =true;
    
    this.startdate = this.authService.getServerDate;
    this.enddate = this.authService.getServerDate;
   
    setTimeout(() => {
      this.get_records_between_two_dates();
      }, 1000);

      setTimeout(() => {
        this.setBargraphData();
        }, 1500);

  }


  setYearlyBargraphData(){
    var d = this.authService.getServerDate;
    d.setMonth(d.getMonth() - 12);
    this.isBarChart = true;
    //  this.isGraph =true;
    this.startdate = d;
    this.enddate = this.authService.getServerDate;
 
  setTimeout(() => {
    this.get_records_between_two_dates();
    }, 1000);

    setTimeout(() => {
      this.setBargraphData();
      }, 1500);
    
  }
  setMonthelyBargraphData(){
    var d = this.authService.getServerDate;
   d.setMonth(d.getMonth() - 1);


this.isBarChart =true;
// this.isGraph =true;

this.startdate = d;
this.enddate = this.authService.getServerDate;

setTimeout(() => {
  this.get_records_between_two_dates();
  }, 1000);

  setTimeout(() => {
    this.setBargraphData();
    }, 1500);
  

    
  }
  setQuaterlyBargraphData(){

    var d = this.authService.getServerDate;
    d.setMonth(d.getMonth() - 3);
    console.log(d)
 
 
 this.isBarChart =true;
//  this.isGraph =true;
 
 this.startdate = d;
 this.enddate = this.authService.getServerDate;
 
 setTimeout(() => {
   this.get_records_between_two_dates();
   }, 1000);
 
   setTimeout(() => {
     this.setBargraphData();
     }, 1500);
   
    
  }
  
  togglemonthelyIf(data:any){

  }

  exportexcel(): void 
    {
       this.exportdata.open_loader_Dialogtwo();
       let element = document.getElementById('content'); 
       this.exportdata.Newexportxcel(element,this.pageHeading);
     }
  
  
  public openPDF():void {
    if( this.isGraph == true){
      this.exportdata.open_loader_Dialogtwo();
      let DATA = document.getElementById('content');
      this.exportdata.Newdownload(DATA,this.pageHeading);

    }
    else{
     this.exportdata.open_loader_Dialogtwo();
    let DATA = document.getElementById('content');
    this.exportdata.downloadAsPDF(DATA,this.pageHeading);
       
    }
  }
  public printPDF(): void {
    this.exportdata.printpDFData(); 
}
  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    this.exportdata.printData(printContents);
    
  }
 
 
  
  
  
  }
  